<div class="accordian">
    <action-coach-accordian-item *ngFor="let item of items">
        <span question>{{item.question}}</span>
        <span answer>{{item.answer}}</span>
    </action-coach-accordian-item>
  </div>